import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RegistroVentasService } from '../Services/registro-ventas.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IUsuarios } from '../interfaces/Usuarios';
import { first } from 'rxjs/operators';
import { IMarcas } from '../interfaces/Marcas';
import { IEdificios } from '../interfaces/Edificios';
import { ErrorResponse } from '../../applicationinfraestructure/interfaces/error-response';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-maestro-usuario-edit',
  templateUrl: './maestro-usuario-edit.component.html',
  styleUrls: ['./maestro-usuario-edit.component.css']
})
export class MaestroUsuarioEditComponent implements OnInit {
  user: IUsuarios;
  editForm: FormGroup;
  marcas: IMarcas[];
  edificios: IEdificios[];
  tipoUsuario = [];
  hide: boolean = true;

  constructor(private router: Router,
    private registroServicios: RegistroVentasService,
    private formBuilder: FormBuilder) { }

    mostrarClave() {
      this.hide = !this.hide;
    }



  ngOnInit(): void {
    this.cargarFormularioEdit();
    this.cargaEdificios();
    this.cargaMarcas();
    this.obtenerTipoUsuario();
    this.obtenerUsuarioId();

  }

  cargaEdificios() {
    this.registroServicios.obtenerEdificios().subscribe(
      resolve => {
        if (resolve != null) {
          this.edificios = resolve;
        }
        else {
          Swal.fire({
            icon: 'error',
            title: 'No se cargaron los edificios...',
            text: 'Valide con el administrador.'
          })
        }

      },
      (error: ErrorResponse) => {
        console.log(error);
      }
    );
  }

  cargaMarcas() {
    this.registroServicios.obtenerMarcas().subscribe(
      resolve => {
        if (resolve != null) {
          this.marcas = resolve;
        }
        else {
          Swal.fire({
            icon: 'error',
            title: 'No se cargaron las marcas...',
            text: 'Valide con el administrador.'
          })
        }

      },
      (error: ErrorResponse) => {
        console.log(error);
      }
    );
  }

  obtenerUsuarioId() {

    let userId = window.sessionStorage.getItem("editUserId");
    if (!userId) {
      alert("Invalid action.")
      this.router.navigate(['/home/registro/AdmUsuario']);
      return;
    }

    this.registroServicios.usuarioId(userId)
      .subscribe(data => {

        const formulario: IUsuarios = {
          identificacion: data.identificacion,
          nombre: data.nombre,
          apellido: data.apellido,
          email: data.email,
          tipoUsuario: data.tipoUsuario,
          clave: data.clave,
          edificiosAutorizados: data.edificiosAutorizados!=null?data.edificiosAutorizados.split(','):"",
          marcasAutorizadas:data.marcasAutorizadas!=null?data.marcasAutorizadas.split(','):"",
          cargo: data.cargo,
          celular: data.celular,
          SubscripciónId:data.SubscripciónId,
        };

        this.editForm.setValue(formulario);
      });
  }

  obtenerTipoUsuario() {
    this.tipoUsuario = [
      { codigo: 'ReporteMarca,Pactia', nombre: 'Pactia' },
      { codigo: 'ReporteMarca,Marca', nombre: 'Marca' },
      { codigo: 'ReporteMarca,MarcaCertificada', nombre: 'Marca venta certificada' },
      { codigo: 'ReporteMarca,Marca,MarcaCertificada', nombre: 'Marca y Marca venta certificada' },
      { codigo: 'ReporteMarca,Administrador', nombre: 'Administrador' },
      { codigo: 'ReporteMarca,AdministradorCertificadas', nombre: 'Administrador ventas certificadas' }

    ];
   }


  cargarFormularioEdit() {
    this.editForm = this.formBuilder.group({
      identificacion: ['', Validators.required],
      nombre: ['', Validators.required],
      apellido: ['', Validators.required],
      email:['', [Validators.required]],
      edificiosAutorizados: [''],
      marcasAutorizadas: [''],
      tipoUsuario: ['', Validators.required],
      clave: ['', Validators.required],
      cargo: [''],
      celular: ['', Validators.required]
    });
  }

  get f() { return this.editForm.controls; }



  onSubmit() {
    if (this.editForm.invalid) {
      return;
  }
    var strEdificios = this.editForm.controls['edificiosAutorizados'].value
    this.editForm.controls['edificiosAutorizados'] = strEdificios.length != 0 ? strEdificios.join(",") : "";

    var strMarcas = this.editForm.controls['marcasAutorizadas'].value
    this.editForm.controls['marcasAutorizadas'] = strMarcas.length != 0 ? strMarcas.join(",") : "";

    const formulario: IUsuarios = {
      ...this.editForm.value,
      edificiosAutorizados: this.editForm.controls['edificiosAutorizados'],
      marcasAutorizadas: this.editForm.controls['marcasAutorizadas']
    };
    this.registroServicios.actualizarUsuario(formulario)
      .subscribe(
        data => {
         this.goBack();
        },
        error => {
          alert(error);
        });
 }

  goBack() {
    this.router.navigate(['home/registro/AdmUsuario']);
  }



  public onSelectAll() {
    const selected = this.edificios.map(item => item.codigo);
    this.editForm.get('edificiosAutorizados').patchValue(selected);
  }

  public onClearAll() {
    this.editForm.get('edificiosAutorizados').patchValue([]);
  }

  public onSelectAllMarcas() {
    const selected = this.marcas.map(item => item.codigo);
    this.editForm.get('marcasAutorizadas').patchValue(selected);
  }

  public onClearAllMarcas() {
    this.editForm.get('marcasAutorizadas').patchValue([]);
  }



}
